<template>
  <div :class="['mobile-container', 'mobile-background', {'app-developer-mode': !appIsLiveSite && !appIsLocalSite, 'app-developer-local-mode': appIsLocalSite}]">
    <transition :name="transitionName">
      <slot />
    </transition>
  </div>
</template>

<style>

/* Transitions */
.next-leave-to {
  animation: leaveToLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  position: absolute;
  z-index: 0;
}

.next-enter-to {
  animation: enterFromRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  position: absolute;
  z-index: 1;
}

.prev-leave-to {
  animation: leaveToRight 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  position: absolute;
  z-index: 1;
}

.prev-enter-to {
  animation: enterFromLeft 500ms both cubic-bezier(0.165, 0.84, 0.44, 1);
  position: absolute;
  z-index: 0;
}

@keyframes leaveToLeft {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
}
@keyframes enterFromLeft {
  from {
    transform: translateX(-25%);
    filter: brightness(0.5);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes leaveToRight {
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(100%);
  }
}
@keyframes enterFromRight {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(0);
  }
}
</style>

<script>
export default {
  name: 'MobileLayout',
  data() {
    return {
      transitionName: ''
    };
  },
  computed: {
    appIsLiveSite() {
      return this.$glass.isLiveSite
    },
    appIsLocalSite() {
      return this.$glass.isLocalSite
    }
  },
  watch: {
    $route(to, from) {
      this.transitionName = to.query.back ? 'prev' : 'next'
    }
  },
};
</script>